import { additionalColors } from "constants/colors";

export const iplDefaultLabelStyling = {
    fontWeight: 700,
    color: additionalColors.grey700,
    backgroundColor: "#FFF",
};

export const iplProjectLabelStyling = {
    1: { fontWeight: 700, color: additionalColors.green700, backgroundColor: "#FFF" },
    3: { fontWeight: 700, color: additionalColors.orangeyRed, backgroundColor: "#FFF" },
    4: { fontWeight: 700, color: additionalColors.orangeyRed, backgroundColor: "#FFF" },
    2: { fontWeight: 700, color: additionalColors.orange, backgroundColor: "#FFF" },
};

export const iplStageLabelStyling = {
    5: { fontWeight: 700, color: additionalColors.green700, backgroundColor: "#FFF" },
    6: { fontWeight: 700, color: additionalColors.orange, backgroundColor: "#FFF" },
};
